import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import type { HomeInstitutionContentDto } from '@generated/unauth';
import { UnauthApi, UnauthQueryKey } from '@/api';
import { InfiniteListWithMoreButton } from '@/app/donation/_components/InfiniteListWithMoreButton';
import { DONATION_ROUTES } from '@/constants';
import { HOMETOWN_SECTION_PAGE_SIZE } from '../../constants';
import { InfiniteListMoreButton } from '../InfiniteListMoreButton';
import { ContentsListItem } from './ContentsListItem';
interface ContentsContentProps {
  institutionId: number;
  institutionSlugId: string;
  initialData?: HomeInstitutionContentDto[];
}
export const ContentsContent = t0 => {
  const $ = _c(12);
  const {
    institutionId,
    institutionSlugId,
    initialData
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("grid grid-cols-3 gap-x-16 gap-y-40", "mobile-tablet:grid-cols-1");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <InfiniteListMoreButton className={cn("mt-28", "mobile-tablet:-mt-16")} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] !== institutionId) {
    t3 = [...UnauthQueryKey["get:/wello/v2/allows/home/institution-content"](), institutionId, HOMETOWN_SECTION_PAGE_SIZE];
    t4 = t5 => {
      const {
        pageParam
      } = t5;
      return UnauthApi["get:/wello/v2/allows/home/institution-content"]({
        query: {
          institutionId,
          page: pageParam,
          size: HOMETOWN_SECTION_PAGE_SIZE
        }
      }).then(_temp);
    };
    $[2] = institutionId;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== institutionSlugId) {
    t5 = (item, index) => <ContentsListItem imageUrl={item.thumbnailUrl} title={item.title} summary={item.summary} timeAgo={item.timeAgo} href={DONATION_ROUTES.HOMETOWNS_CONTENTS_DETAIL.pathname({
      hometownsId: institutionSlugId,
      contentsId: item.contentId
    })} priority={index < 2} />;
    $[5] = institutionSlugId;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== initialData || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <div><div className={t1}><InfiniteListWithMoreButton initialData={initialData} moreButtonComponent={t2} queryKey={t3} queryFn={t4} pageSize={HOMETOWN_SECTION_PAGE_SIZE} renderItem={t5} getItemKey={_temp2} /></div></div>;
    $[7] = initialData;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
function _temp(data) {
  return data.data?.context?.contents ?? [];
}
function _temp2(item_0) {
  return item_0.contentId;
}